// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { menuItemBadgeStyles } from "@eisinc/App/Components/MenuItemBadge/MenuItemBadge";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

menuItemBadgeStyles.wrapper = {
    css: css`
        background: ${color("text.main")};
        padding: 2px 4px 1px;
        display: flex;

        && ${TypographyStyle} {
            color: ${color("common.white")};
        }
    `,
};

menuItemBadgeStyles.textBadge = {
    size: 10,
    lineHeight: "12px",
    weight: fontConfig.weight.medium,
};
